<template>

<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg9"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs13"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath23"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path21" /></clipPath></defs><g
     id="g15"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g17"><g
         id="g19"
         clip-path="url(#clipPath23)"><g
           id="g25"
           transform="translate(256,226)"><path
             d="m 0,0 c 5.52,0 10,-4.48 10,-10 0,-5.52 -4.48,-10 -10,-10 -5.52,0 -10,4.48 -10,10 0,5.52 4.48,10 10,10"
             style="fill:#000000;fill-opacity:1;fill-rule:nonzero;stroke:none"
             id="path27" /></g><g
           id="g29"
           transform="translate(276,116)"><path
             d="m 0,0 c 0,-11.05 -8.95,-20 -20,-20 -11.05,0 -20,8.95 -20,20 0,11.05 8.95,20 20,20 C -8.95,20 0,11.05 0,0 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path31" /></g><g
           id="g33"
           transform="translate(256,76)"><path
             d="m 0,0 c -22.09,0 -40,-17.91 -40,-40 v -26 h 80 v 26 C 40,-17.91 22.09,0 0,0 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path35" /></g><g
           id="g37"
           transform="translate(276,482)"><path
             d="m 0,0 c 0,-11.05 -8.95,-20 -20,-20 -11.05,0 -20,8.95 -20,20 0,11.05 8.95,20 20,20 C -8.95,20 0,11.05 0,0 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path39" /></g><g
           id="g41"
           transform="translate(256,442)"><path
             d="m 0,0 c -22.09,0 -40,-17.91 -40,-40 v -26 h 80 v 26 C 40,-17.91 22.09,0 0,0 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path43" /></g><g
           id="g45"
           transform="translate(136,482)"><path
             d="m 0,0 c 0,-11.05 -8.95,-20 -20,-20 -11.05,0 -20,8.95 -20,20 0,11.05 8.95,20 20,20 C -8.95,20 0,11.05 0,0 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path47" /></g><g
           id="g49"
           transform="translate(116,442)"><path
             d="m 0,0 c -22.09,0 -40,-17.91 -40,-40 v -26 h 80 v 26 C 40,-17.91 22.09,0 0,0 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path51" /></g><g
           id="g53"
           transform="translate(416,482)"><path
             d="m 0,0 c 0,-11.05 -8.95,-20 -20,-20 -11.05,0 -20,8.95 -20,20 0,11.05 8.95,20 20,20 C -8.95,20 0,11.05 0,0 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path55" /></g><g
           id="g57"
           transform="translate(396,442)"><path
             d="m 0,0 c -22.09,0 -40,-17.91 -40,-40 v -26 h 80 v 26 C 40,-17.91 22.09,0 0,0 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path59" /></g><g
           id="g61"
           transform="translate(416,116)"><path
             d="m 0,0 c 0,-11.05 -8.95,-20 -20,-20 -11.05,0 -20,8.95 -20,20 0,11.05 8.95,20 20,20 C -8.95,20 0,11.05 0,0 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path63" /></g><g
           id="g65"
           transform="translate(396,76)"><path
             d="m 0,0 c -22.09,0 -40,-17.91 -40,-40 v -26 h 80 v 26 C 40,-17.91 22.09,0 0,0 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path67" /></g><g
           id="g69"
           transform="translate(136,116)"><path
             d="m 0,0 c 0,-11.05 -8.95,-20 -20,-20 -11.05,0 -20,8.95 -20,20 0,11.05 8.95,20 20,20 C -8.95,20 0,11.05 0,0 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path71" /></g><g
           id="g73"
           transform="translate(116,76)"><path
             d="m 0,0 c -22.09,0 -40,-17.91 -40,-40 v -26 h 80 v 26 C 40,-17.91 22.09,0 0,0 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path75" /></g><g
           id="g77"
           transform="translate(257.7202,246)"><path
             d="m 0,0 c 1.94,5.51 5.48,10.4 10.27,13.99 4.86,3.65 8.01,9.46 8.01,16.01 0,11.05 -8.95,20 -20,20 -11.05,0 -20,-8.95 -20,-20"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path79" /></g><g
           id="g81"
           transform="translate(396,136)"><path
             d="M 0,0 V 80 H -60"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path83" /></g><g
           id="g85"
           transform="translate(396,376)"><path
             d="M 0,0 V -80 H -60"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path87" /></g><g
           id="g89"
           transform="translate(116,136)"><path
             d="M 0,0 V 80 H 60"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path91" /></g><g
           id="g93"
           transform="translate(116,376)"><path
             d="M 0,0 V -80 H 60"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path95" /></g><g
           id="g97"
           transform="translate(256,376)"><path
             d="M 0,0 V -40"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path99" /></g><g
           id="g101"
           transform="translate(266,176)"><path
             d="m 0,0 c 0,-5.523 -4.477,-10 -10,-10 -5.523,0 -10,4.477 -10,10 0,5.523 4.477,10 10,10 C -4.477,10 0,5.523 0,0"
             style="fill:#000000;fill-opacity:1;fill-rule:nonzero;stroke:none"
             id="path103" /></g><g
           id="g105"
           transform="translate(211,176)"><path
             d="M 0,0 H -35 V 160 H 125 V 0 H 90"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path107" /></g></g></g></g></svg>
</template>
